
import "../styles/Calculator.css"
import { useState } from "react"
import Button from "./Button"


const Calculator = () => {

    const [display, setDisplay] = useState("")
    const [hasOp, setHasOp] = useState(false)


    const handleInput = (x) => {
        if (/[0-9a-fA-F]+/.test(x)) {

        }
    }

    const isOp = (x) => {
        return ops.hasOwnProperty(x)
    }

    const ops = {
        "+": (x, y) => x + y,
        "-": (x, y) => x - y,
        "/": (x, y) => x / y,
        "*": (x, y) => x * y,
    }

    const calculate = () => {
        let i = display.indexOf(hasOp)
        let left = parseInt(display.slice(0, i), 16)
        let right = parseInt(display.slice(i + 1, display.length), 16)

        return ((ops[hasOp](left, right)).toString(16)).toUpperCase()
    }

    const addToDisplay = (x) => {
        return ((e) => {
            if (x === "CLEAR") {
                setDisplay("")
                setHasOp("")
                return
            }
            if (isOp(x)) {
                if (display.length === 0) {
                    return
                }
                if (hasOp) {
                    return
                }
                setHasOp(x)
            }
            if (x === "=") {
                setDisplay(calculate())
                setHasOp("")
                return
            }
            setDisplay(display + x)
        })
    }

    return (
        <div className="calculator">
            <div className="display">
                {display}
            </div>

            <div>
                {["C", "D", "E", "F", "/"].map((e, i) => <Button value={e} className={e} callback={addToDisplay(e)} key={i} />)}
            </div>
            <div>
                {["8", "9", "A", "B", "*"].map((e, i) => <Button value={e} className={e} callback={addToDisplay(e)} key={i} />)}
            </div>
            <div>
                {["4", "5", "6", "7", "-"].map((e, i) => <Button value={e} className={e} callback={addToDisplay(e)} key={i} />)}
            </div>
            <div>
                {["0", "1", "2", "3", "+"].map((e, i) => <Button value={e} className={e} callback={addToDisplay(e)} key={i} />)}
            </div>
            <div className="wide">
                <div>
                    <Button value={"="} callback={addToDisplay("=")} />
                </div>
                <div>
                    <Button id="clear" value={"CLEAR"} callback={addToDisplay("CLEAR")} />
                </div>
            </div>

        </div>
    )
}

export default Calculator
